import { Link } from '@remix-run/react'

const ClickRate = () => {
	return (
		<div className="flex h-screen w-screen flex-col items-center justify-center gap-16 bg-[url('/img/background-click-rate.webp')] bg-cover bg-center text-center text-white">
			<h2 className="hidden text-6xl font-extrabold sm:block">
				94% proklikovost
			</h2>
			{/* mobile */}
			<h2 className=" text-4xl font-extrabold sm:hidden">
				94% <br /> proklikovost
			</h2>
			<p>Až 94 % uživatelů si vaší zaslanou notifikaci přečte a rozklikne.</p>
			<button className="w-[217px] rounded-[90px] bg-primary px-14 py-4">
				<Link to="#contact">To chci také!</Link>
			</button>
		</div>
	)
}

export default ClickRate
